const isYtShort = (url: string): boolean => {
  const exp =
    /^https:\/\/(?:www\.|m\.)?youtube\.com\/shorts\/([_\-a-zA-Z0-9]{11}).*$/
  const match = exp.exec(url)
  return match !== null && match.length > 1
}

export default isYtShort
